<template>
  <div>
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
    <div style="text-align: center;">
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'load',

  props: {
    text: {
      type: String,
      default: 'Procesando',
    },
  },
  data() {
    return {};
  },
};
</script>
